import { useEffect, useState } from 'react';

import { fetch_rule_approvals } from './api';
import { approvals_missing, queue_view } from './logic';

/*
 * PROD-7828 R14 P6 (13 Oct review) — how many rule changes wait for approval, for the Rules tab's badge.
 * Read on mount, when `rev` moves (a write in the Rules tab), and every poll_ms while the page is
 * visible. While the Rules tab is open (paused) it reads nothing: the tab polls the same endpoint for
 * its queue and feeds the count through the returned setter, so the page polls it once. A 404 (an older
 * goserver during the deploy) reads as 0; any other failed read keeps the last count.
 * Returns [count, set_count].
 */
export const useApprovalsCount = (rev = 0, { poll_ms = 60000, paused = false } = {}) => {
  const [count, setCount] = useState(0);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (paused) return undefined;
    let cancelled = false;
    fetch_rule_approvals()
      .then((data) => {
        if (!cancelled) setCount(queue_view(data).waiting);
      })
      .catch((e) => {
        if (!cancelled && approvals_missing(e)) setCount(0);
      });
    return () => {
      cancelled = true;
    };
  }, [rev, tick, paused]);

  useEffect(() => {
    if (!poll_ms || paused) return undefined;
    const visible = () => document.visibilityState !== 'hidden';
    const t = setInterval(() => {
      if (visible()) setTick((n) => n + 1);
    }, poll_ms);
    return () => clearInterval(t);
  }, [poll_ms, paused]);

  return [count, setCount];
};

export default useApprovalsCount;
